type Props = {
  steps: string[];
  current: number;
  label?: string;
  onJump?: (index: number) => void;
};

export default function FlowStepper({ steps, current, label = 'Workflow', onJump }: Props) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg px-4 md:px-5 py-4">
      <p className="font-label uppercase tracking-widest text-[11px] text-foreground-500 mb-3">{label}</p>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-3">
        {steps.map((step, i) => {
          const done = i < current;
          const active = i === current;
          const chipClass = active
            ? 'bg-primary-500 border-primary-500 text-background-50'
            : done
              ? 'bg-primary-100 border-primary-200 text-primary-700'
              : 'bg-background-100 border-background-200 text-foreground-500';
          const chip = (
            <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border font-label uppercase tracking-wide text-[10px] font-semibold whitespace-nowrap ${chipClass}`}>
              <span className="w-4 h-4 flex items-center justify-center">
                {done ? <i className="ri-check-line"></i> : <i className={active ? 'ri-record-circle-line' : 'ri-circle-line'}></i>}
              </span>
              <span className="hidden sm:inline">{step}</span>
              <span className="sm:hidden">{i + 1}</span>
            </span>
          );
          return (
            <div key={step} className="flex items-center gap-2">
              {onJump && (done || active) ? (
                <button type="button" onClick={() => onJump(i)} className="cursor-pointer">{chip}</button>
              ) : chip}
              {i < steps.length - 1 && (
                <span className="hidden sm:flex w-4 items-center justify-center text-foreground-300"><i className="ri-arrow-right-line"></i></span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}